import { defineEffect } from '../../../core/effect';

/**
 * **通常召喚しようとする**（Issue #537）。
 *
 * 開く: `summoning`（まだ無効にされうる瞬間）。出る場所で魔法陣が開き、光の柱が立ち、
 * カードが降りてくる。成功した瞬間のアップは `summoned`（別のファイル）。
 *
 * 種類ごとの色は**そのファイルが持つ**（`spsummoning` は紫・`flipsummoning` は水色）——
 * 旧 `components/fx` では 1 ファイルが `STYLE` の表で 3 種を分けていたが、
 * **1 ファイル = 1 イベント**なので表が要らない。
 */
const COLOR = '#ffc43d';

export default defineEffect({
  situation: 'summoning',
  label: '通常召喚',
  color: COLOR,
  sounds: () => [{ at: 0, name: 'summon' }],

  opens({ payload }) {
    return payload?.zone ? payload : null;
  },

  layers: [
    {
      id: 'circle',
      label: '魔法陣',
      part: 'ring',
      at: { card: '{uid}', else: { zone: '{zone}' } },
      props: { color: COLOR, ticks: 12, tickLen: 0.08, width: 8 },
      tf: {
        scale: { keys: [{ ms: 120, value: 0.2 }, { ms: 520, value: 2.4, ease: 'ease_out' }, { ms: 1320, value: 2.4 }] },
        opacity: { keys: [{ ms: 120, value: 0 }, { ms: 300, value: 1 }, { ms: 1100, value: 1 }, { ms: 1320, value: 0 }] },
        rotation: { keys: [{ ms: 120, value: 0 }, { ms: 1320, value: 180 }] },
      },
    },
    {
      id: 'pillar',
      label: '光の柱',
      part: 'beam',
      parent: 'circle',
      props: { color: COLOR, core: 0.12 },
      tf: {
        rotation: 90,
        scale: { keys: [{ ms: 200, value: 0.2 }, { ms: 420, value: 0.9, ease: 'ease_out' }, { ms: 1000, value: 0.4 }] },
        opacity: { keys: [{ ms: 200, value: 0 }, { ms: 420, value: 0.9 }, { ms: 1000, value: 0 }] },
      },
    },
    {
      id: 'card',
      label: '降りてくるカード',
      part: 'card',
      at: { card: '{uid}', else: { zone: '{zone}' } },
      props: { code: '{code}', player: '{player}', glow: COLOR, glowW: 6 },
      tf: {
        // 行き過ぎてから戻って落ち着く（着地の重み）
        scale: { keys: [{ ms: 300, value: 1.6 }, { ms: 760, value: 0.92, ease: 'ease_out' }, { ms: 900, value: 1 }] },
        opacity: { keys: [{ ms: 300, value: 0 }, { ms: 420, value: 1 }, { ms: 1100, value: 1 }, { ms: 1320, value: 0 }] },
        y: { keys: [{ ms: 300, value: -260 }, { ms: 760, value: 0, ease: 'ease_out' }] },
      },
    },
  ],
}, 'summoning_effect.js');
